
import React from "react";
import styles from "./Force.module.css";
import ForceCardComponent from "./ForceCardComponent";
import { ForceTypes } from "@/types/displayData/ForceTypes";

const ForceComponent: React.FC<ForceTypes> = ({ features }) => {
  if (!Array.isArray(features) || features.length === 0) {
    return <p className={styles.noFeatures}>Aucune donnée disponible</p>;
  }

  return (
    <section className={styles.advantagesSection}>
      <div className={styles.advantagesContainer}>
        {features.map((feature, index) => (
          <ForceCardComponent key={index} title={feature.title} description={feature.description} />
        ))}
      </div>
    </section>
  );
};

export default ForceComponent;
